import ModalStore from "../../stores/ModalStore";

const useModals = () => {
  
  return {openModal: ModalStore.open, closeModal: ModalStore.close};
};

export default useModals;